
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"8","cy":"8","r":"8","fill":"#fff"}}),_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M7.004 12a.808.808 0 01-.58-.247L3.24 8.484a.858.858 0 010-1.192.805.805 0 011.161 0l2.603 2.673 4.595-4.718c.32-.33.84-.33 1.16 0a.858.858 0 010 1.192l-5.175 5.314a.808.808 0 01-.58.247z","fill":"#8F7A61"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(3 5)","d":"M0 0h10v7H0z"}})])])])
          )
        }
      }
    